import { logEvent } from './googleAnalytics';

// Parse UTM parameters from URL (works with both HashRouter and BrowserRouter)
export const getUTMParams = () => {
  // For HashRouter, check both before and after the hash
  let searchParams = window.location.search;

  // If no params before hash, check after hash
  if (!searchParams && window.location.hash) {
    const hashParts = window.location.hash.split('?');
    if (hashParts.length > 1) {
      searchParams = '?' + hashParts[1];
    }
  }

  const params = new URLSearchParams(searchParams);
  const utmParams = {};

  // Standard UTM parameters
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  utmKeys.forEach(key => {
    const value = params.get(key);
    if (value) {
      utmParams[key] = value;
    }
  });

  return utmParams;
};

// Store UTM parameters in sessionStorage for attribution
export const storeUTMParams = () => {
  const utmParams = getUTMParams();

  if (Object.keys(utmParams).length > 0) {
    sessionStorage.setItem('utm_params', JSON.stringify(utmParams));

    // Track the campaign arrival
    trackCampaignArrival(utmParams);
  }
};

// Get stored UTM parameters
export const getStoredUTMParams = () => {
  const stored = sessionStorage.getItem('utm_params');
  return stored ? JSON.parse(stored) : {};
};

// Track when user arrives from a campaign
export const trackCampaignArrival = (utmParams) => {
  if (utmParams.utm_source) {
    logEvent('Campaign', 'arrival', `${utmParams.utm_source}_${utmParams.utm_medium}`, {
      campaign_source: utmParams.utm_source,
      campaign_medium: utmParams.utm_medium,
      campaign_name: utmParams.utm_campaign,
      campaign_content: utmParams.utm_content,
      campaign_term: utmParams.utm_term
    });
  }
};

// Enhanced CTA tracking with UTM attribution
export const trackCTAWithAttribution = (ctaName, ctaLocation) => {
  const utmParams = getStoredUTMParams();

  // Create event label combining CTA info and UTM content
  const eventLabel = utmParams.utm_content
    ? `${ctaName}_${utmParams.utm_content}`
    : ctaName;

  // Track with full attribution
  logEvent('CTA', 'click', eventLabel, {
    cta_name: ctaName,
    cta_location: ctaLocation,
    campaign_source: utmParams.utm_source || 'direct',
    campaign_medium: utmParams.utm_medium || 'none',
    campaign_name: utmParams.utm_campaign || 'none',
    campaign_content: utmParams.utm_content || 'none'
  });
};

// Track form submission with UTM attribution
export const trackFormWithAttribution = (formName, formData = {}) => {
  const utmParams = getStoredUTMParams();

  logEvent('Form', 'submit', formName, {
    form_name: formName,
    campaign_source: utmParams.utm_source || 'direct',
    campaign_medium: utmParams.utm_medium || 'none',
    campaign_name: utmParams.utm_campaign || 'none',
    campaign_content: utmParams.utm_content || 'none',
    ...formData
  });
};

// Track conversions with full attribution
export const trackConversionWithAttribution = (conversionType) => {
  const utmParams = getStoredUTMParams();

  logEvent('Conversion', conversionType, 'completed', {
    conversion_type: conversionType,
    campaign_source: utmParams.utm_source || 'direct',
    campaign_medium: utmParams.utm_medium || 'none',
    campaign_name: utmParams.utm_campaign || 'none',
    campaign_content: utmParams.utm_content || 'none'
  });
};

// Clear UTM parameters (useful after conversion)
export const clearUTMParams = () => {
  sessionStorage.removeItem('utm_params');
};
